import StudioDocumentAPI from 'dashboard/api/studio/document';
import { createStore } from '../captain/storeFactory';

const SET_FIRECRAWL_CONFIG = 'SET_FIRECRAWL_CONFIG';
const SET_EMBEDDING_ACCESS = 'SET_EMBEDDING_ACCESS';

const store = createStore({
  name: 'StudioDocument',
  API: StudioDocumentAPI,
  getters: {
    getFirecrawlConfig: state => state.firecrawlConfig || {},
    getEmbeddingAccess: state => state.embeddingAccess || {},
  },
  actions: () => ({
    fetchFirecrawlConfig: async ({ commit }) => {
      try {
        const response = await StudioDocumentAPI.getFirecrawlConfig();
        commit(SET_FIRECRAWL_CONFIG, response.data);
        return response.data;
      } catch (error) {
        return {};
      }
    },
    // A chave da conta alcança o modelo que indexa a base? Falha da consulta
    // zera o estado (tela libera): a API recusa de novo no create, com a
    // mensagem do motivo, então o bloqueio não depende desta leitura.
    fetchEmbeddingAccess: async ({ commit }) => {
      try {
        const response = await StudioDocumentAPI.getEmbeddingAccess();
        commit(SET_EMBEDDING_ACCESS, response.data);
        return response.data;
      } catch (error) {
        commit(SET_EMBEDDING_ACCESS, {});
        return {};
      }
    },
    saveFirecrawlConfig: async ({ commit }, apiKey) => {
      const response = await StudioDocumentAPI.updateFirecrawlConfig(apiKey);
      const configResponse = await StudioDocumentAPI.getFirecrawlConfig();
      commit(SET_FIRECRAWL_CONFIG, configResponse.data);
      return response.data;
    },
    uploadFile: async (_, { file, agentId, name }) => {
      const response = await StudioDocumentAPI.uploadFile({
        file,
        agentId,
        name,
      });
      return response.data;
    },
  }),
});

// Add firecrawlConfig to state
store.state.firecrawlConfig = {};
store.state.embeddingAccess = {};

// Add custom mutation
store.mutations[SET_FIRECRAWL_CONFIG] = (state, config) => {
  state.firecrawlConfig = config;
};

store.mutations[SET_EMBEDDING_ACCESS] = (state, access) => {
  state.embeddingAccess = access;
};

export default store;
